import { Component, Input } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { AddEvent, CancelEvent, EditEvent, GridComponent, RemoveEvent, SaveEvent } from '@progress/kendo-angular-grid';
import { BOM_FixedCutterGaugePadElement } from '../../../interfaces/request';
import { OptionState } from '../../../store/state/options.state';
import { Store } from '@ngxs/store';
import { Observable, takeUntil } from 'rxjs';
import { Picklist } from '../../../interfaces/request.interface';

@Component({
    selector: 'app-gaugeprotection-data',
    templateUrl: './gaugeprotection-data.component.html',
    styleUrl: './gaugeprotection-data.component.css',
    standalone: false
})
export class GaugeprotectionDataComponent {
  constructor(private fb: FormBuilder, private store: Store) {
  }
  @Input() GaugeElements!: any[];
  private editedRowIndex!: number;
  @Input() GaugePadElements$!: Observable<any[]>;
  public data: BOM_FixedCutterGaugePadElement[] = [];
  private updateddata: BOM_FixedCutterGaugePadElement[] = [];
  private createddata: BOM_FixedCutterGaugePadElement[] = [];
  private removeddata: BOM_FixedCutterGaugePadElement[] = [];
  private counter!: number;

  
 

  public formGroup!: FormGroup;


  public ngOnInit(): void {
    this.counter = this.data.length;
  }
  public addHandler(args: AddEvent): void {
    this.closeEditor(args.sender);
    this.formGroup = createFormGroup({
      id: 0,
      preBOMID: 0,
      type: '',
      quantity: 0,
      sapMaterialNumber: 0
    })

    args.sender.addRow(this.formGroup);
  }
  public editHandler({ sender, rowIndex, dataItem }: EditEvent): void {
    this.closeEditor(sender);
    this.formGroup = createFormGroup(dataItem);
    this.editedRowIndex = rowIndex;
    sender.editRow(rowIndex, this.formGroup);
  }
  public cancelHandler(args: CancelEvent): void {
    this.closeEditor(args.sender, args.rowIndex);
  }
  public saveHandler({ sender, rowIndex, formGroup, isNew }: SaveEvent): void {
    const _saveData = formGroup.value;
    if (isNew) {
      _saveData.ID = this.counter++;
      this.data.splice(0, 0, _saveData);
      this.createddata.push(_saveData);
    } else {
      // Object.assign(
      //   this.data.find(({ ID }) => ID === _saveData.ID),
      //   _saveData
      // );
      this.updateddata.push(_saveData);
    }
    sender.closeRow(rowIndex);
  }
  public removeHandler(args: RemoveEvent): void {
    //this.editService.remove(args.dataItem);
  }
  private closeEditor(
    grid: GridComponent,
    rowIndex = this.editedRowIndex
  ): void {
    grid.closeRow(rowIndex);
    //this.editedRowIndex = undefined;
    //this.formGroup = undefined;
  }
}
const createFormGroup = (dataItem: BOM_FixedCutterGaugePadElement) => {
  const formGroup = new FormGroup({
    id: new FormControl(dataItem.id),
    preBOMID: new FormControl(dataItem.preBOMID),
    type: new FormControl(dataItem.type),
    sapMaterialNumber: new FormControl(dataItem.sapMaterialNumber),
    quantity: new FormControl(dataItem.quantity, Validators.compose([
      Validators.required,
      Validators.pattern("^[0-9]{1,6}"),
    ]))
  });
  return formGroup;
};
